import React from 'react';
import 'src/styles/bill.css';
import QRCode from "react-qr-code";

const getTLVForValue = (tagNum, tagValue) => {
  const tagBuf = Buffer.from([tagNum], 'utf8');
  const tagValueLenBuf = Buffer.from([tagValue.length], 'utf8')
  const tagValueBuf = Buffer.from(tagValue, 'utf8');
  const bufsArray = [tagBuf, tagValueLenBuf, tagValueBuf]
  return Buffer.concat(bufsArray);
}

export const getQRCodeData = (amount, vatAmount, dateTime, intl) => {
  let data = getTLVForValue(1, intl.formatMessage({id: 'payment.businessNameUTF8'}));
  // let data = getTLVForValue(1, 'Sennem Solutions for Telecommunication and Information Technology');
  data += getTLVForValue(2, '310210374900003');
  data += getTLVForValue(3, dateTime.toString());
  data += getTLVForValue(4, ''+ amount);
  data += getTLVForValue(5, ''+ vatAmount);
  return btoa(data);
}

function PaymentBill({
                       isLTR,
                       storeName,
                       invoiceNo,
                       invoiceDate,
                       userName,
                       userCityName,
                       userEmail,
                       itemName,
                       itemQuantity,
                       itemValue,
                       itemVATValue,
                       itemTotalValue,
                       taxName,
                       taxValue,
                       subTotalName,
                       subTotalValue,
                       totalValue,
                       invoiceText,
                       billToText,
                       totalText,
                       priceText,
                       unitText,
                       vatText,
                       itemTotalText,
                       itemText,
                       businessName,
                       businessPlace,
                       businessTIN,
                       businessCommercialNo,
                       qrCode,
                     }) {
  return (
    <div id={'idInvoice'} className="container-wrapper">
      <div className="container">
        <div className="top-wrapper">
          <div className="logo-wrapper">
            <img src={require('src/images/logo.png')} alt="Store Logo" width="26"/>
            <div style={{width: 12}}/>
            <div className="store-name">{storeName}</div>
          </div>
          <div className="invoice-text">{invoiceText}</div>
          <div className="invoice-info">
            <div>#{invoiceNo}</div>
          </div>
          <div className="invoice-date">
            <div>{invoiceDate}</div>
          </div>
        </div>

        <div className="separator"></div>
        <div className="company-details">
          <div style={{fontSize: 14}}>{businessName}</div>
          <div>{businessPlace}</div>
          <div>{businessTIN}</div>
          <div>{businessCommercialNo}</div>
        </div>
        <div className="separator"></div>
        <div className="bill-to">{billToText}</div>
        <div className="customer-details">
          <div>{userName}</div>
          <div className={"customer-sub-details"}>{userCityName}</div>
          <div className={"customer-sub-details"}>{userEmail}</div>
        </div>
        <div className="separator"></div>
        <div className="table-header">
          <div className="item" style={{fontWeight: "bold"}}>{itemText}</div>
          <div className="quantity">{unitText}</div>
          <div className="price">{priceText}</div>
          <div className="price">{vatText}</div>
          <div className="item-total">{itemTotalText}</div>
        </div>
        <div className="separator"></div>
        <div className="items">
          <div className="item">{itemName}</div>
          <div className="quantity">{itemQuantity}</div>
          <div className="price">{itemValue}</div>
          <div className="price">{itemVATValue}</div>
          <div className="item-total">{itemTotalValue}</div>
          {/* Add more items as needed */}
        </div>
        <div className="separator"></div>
        <div className="sub-total">
          <div>{subTotalName}</div>
          <div className="total-value">{subTotalValue}</div>
        </div>
        <div className="sub-total" style={{marginBottom: 6}}>
          <div>{taxName}</div>
          <div className="total-value">{taxValue}</div>
        </div>
        <div className="separator"></div>
        <div className="total">
          <div>{totalText}</div>
          <div className="total-value">{totalValue}</div>
        </div>
        <div className="qrcode">
          <QRCode
            id={'qrCodeInvoice'}
            style={{height: "auto", maxWidth: "100%", width: "100%"}}
            value={qrCode}
            level={'M'}
          />
        </div>
      </div>
    </div>
  );
}

export default PaymentBill;
